import { useQuery } from '@apollo/client';

import { GetVirtualCardInitialLimitsDocument } from './getVirtualCardInitialLimits.gql';

export const useVirtualPaymentCardLimits = () => {
  const { data, ...hook } = useQuery(GetVirtualCardInitialLimitsDocument);

  if (!data) {
    return {
      ...hook,
      limits: null,
    };
  }

  const virtualPaymentCardData = data.virtualCardInitialLimits;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { __typename, ...limits } = virtualPaymentCardData;

  return {
    ...hook,
    limits,
  };
};

export type VirtualPaymentCardLimits = NonNullable<
  ReturnType<typeof useVirtualPaymentCardLimits>['limits']
>;

export { GetVirtualCardInitialLimitsDocument };
